var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-container"},[_c('van-sidebar',{staticClass:"sidebar-con",attrs:{"active-key":-1}},_vm._l((_vm.menuData),function(item,index){return _c('SidebarItem',{key:item.id,ref:"sidebarItem",refInFor:true,attrs:{"menu":item,"level":0,"active-id":_vm.currentActiveId},on:{"toggleChildren":_vm.toggleChildren}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }